import { Controller, useFormContext } from 'react-hook-form';
import { Box, Stack } from '@chakra-ui/react';
import { Typography } from '@shinetools/sunshine-universal';

import { ShineAccountingExportFormat } from '__generated__/GQL';
import * as Form from 'components/_core/form';
import SunshineCard from 'components/_core/SunshineCard';

import { AccountingExportSchema } from '../../accountingExport.schema';
import locales from './locales';

export const Options = () => {
  const { control } = useFormContext<AccountingExportSchema>();

  return (
    <SunshineCard>
      <Stack gap="space-16">
        <Typography.Text bold size="large">
          {locales.title}
        </Typography.Text>

        <Box marginBottom="space-8">
          <Controller
            control={control}
            name="formats"
            render={({ field: { onChange, value } }) => (
              <SunshineCard.CheckboxGroup
                direction="row"
                onChange={onChange}
                value={value}
              >
                <SunshineCard
                  isActive={value?.includes(ShineAccountingExportFormat.Csv)}
                  title={locales.format.CSV}
                  value={ShineAccountingExportFormat.Csv}
                  variant="checkbox"
                />

                <SunshineCard
                  isActive={value?.includes(ShineAccountingExportFormat.Qif)}
                  title={locales.format.QIF}
                  value={ShineAccountingExportFormat.Qif}
                  variant="checkbox"
                />

                <SunshineCard
                  isActive={value?.includes(ShineAccountingExportFormat.Ofx)}
                  title={locales.format.OFX}
                  value={ShineAccountingExportFormat.Ofx}
                  variant="checkbox"
                />
              </SunshineCard.CheckboxGroup>
            )}
          />
        </Box>

        <Controller
          control={control}
          name="includeInvoices"
          render={({ field: { onChange, value } }) => (
            <Form.Checkbox isChecked={value} onChange={onChange}>
              <Form.Checkbox.Title variant="primary">
                {locales.includeInvoices}
              </Form.Checkbox.Title>
            </Form.Checkbox>
          )}
        />

        <Controller
          control={control}
          name="includePersonalTransactions"
          render={({ field: { onChange, value } }) => (
            <Form.Checkbox isChecked={value} onChange={onChange}>
              <Form.Checkbox.Title variant="primary">
                {locales.includePersonalTransactions}
              </Form.Checkbox.Title>
            </Form.Checkbox>
          )}
        />

        <Controller
          control={control}
          name="includeBankStatements"
          render={({ field: { onChange, value } }) => (
            <Form.Checkbox isChecked={value} onChange={onChange}>
              <Form.Checkbox.Title variant="primary">
                {locales.includeBankStatements}
              </Form.Checkbox.Title>
            </Form.Checkbox>
          )}
        />
      </Stack>
    </SunshineCard>
  );
};
